import { useLanguage } from "contexts/LocalizationContext";
import { ArrowRightAltIcon } from "styles/icons";
import getDomainFromLanguage from "utils/getDomainFromLanguage";
import { ChakraFlex as Flex, ChakraBox as Box, ChakraLink as Link } from "@airhelp/react-ui-components";
import type { BreadcrumbsProps } from "./Breadcrumbs.d";

const Breadcrumbs = ({ parentValue, childValue }: BreadcrumbsProps) => {
  const language = useLanguage();
  const domain = getDomainFromLanguage(language);
  const isStrikePage = parentValue === "Strike";

  return (
    <Flex alignItems="center" py={4}>
      <Link
        href={`${domain}/${language}/`}
        color="primary.500"
        fontSize="sm"
        fontWeight="normal"
        _hover={{ color: "primary.600" }}
      >
        AirHelp
      </Link>
      <ArrowRightAltIcon color="gray.500" />
      {!isStrikePage ? (
        <Link
          href={`${domain}/${language}/${parentValue.toLowerCase()}/`}
          color="primary.500"
          fontSize="sm"
          fontWeight="normal"
          _hover={{ color: "primary.600" }}
        >
          {parentValue}
        </Link>
      ) : (
        <Box fontSize="sm" color="primary.700">
          {parentValue}
        </Box>
      )}
      {childValue && (
        <>
          <ArrowRightAltIcon color="gray.500" />
          <Box fontSize="sm" color="primary.700">
            {childValue}
          </Box>
        </>
      )}
    </Flex>
  );
};

export default Breadcrumbs;
